import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const EfairsJobListPage = lazy(() => import("@feature/pages/EfairsJobList"));
// const CreateShowPage = lazy(() => import("@feature/pages/CreateShow"));
// const UpdateShowPage = lazy(() => import("@feature/pages/UpdateShow"));

@injectable()
@registry([{ token: FeatureToken, useClass: ShowList }])
class ShowList implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Show List",
                path: featurePaths.EfairsJobList,
                page:   EfairsJobListPage
            }
            // ,
            // {
            //     title: "Create Show",
            //     path: featurePaths.CreateShow,
            //     page: CreateShowPage
            // },
            // {
            //     title: "Update Show",
            //     path: featurePaths.EditShow,
            //     page: UpdateShowPage
            // }
        ]
    };
}
